module.exports = __webpack_public_path__ + "icons/original/small/small-f4.fa8fa0e7c09873297312ed5082eac413.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-f4.png
// module id = yNUn
// module chunks = app